/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  MainContainer, Paragraph, Image,
} from './StyledComponents';
import formatDate from '../services/formatDate';
import logo from '../images/icon-192x192.png';
import back from '../images/back (1).svg';

export default class ComingSoon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: formatDate(new Date()),
    };
  }

  async componentDidMount() {
    setInterval(() => this.tick(), 1000);
  }

  tick() {
    this.setState({ date: formatDate(new Date()) });
  }

  render() {
    const { date } = this.state;
    const studentDetails = JSON.parse(localStorage.getItem('studentDetails'));
    const { history } = this.props;
    if (!studentDetails) {
      history.push('/');
      return 0;
    }
    return (
      <MainContainer className="student-detail-page">
        <div className="coming-soon">
          <div className="come-soon-header">
            <div
              onClick={() => {
                history.push('/studentDetails');
              }}
              role="button"
            >
              <Image
                alt="Back"
                className="come-back-icon"
                src={back}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = logo;
                }}
              />
            </div>
            <div
              role="button"
              className="options-btn"
              tabIndex={0}
              onKeyPress={() => {}}
            >
              <span><i className="fa fa-ellipsis-h" aria-hidden="true" /></span>
            </div>
          </div>
          <div className="come-soon-wrapper">
            <div className="come-soon-school">
              <Image
                alt="School Logo"
                src={studentDetails.school_logo}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = logo;
                }}
              />
            </div>
            <Paragraph
              style={{ fontWeight: 'bold', fontSize: '35px' }}
            >
              Coming soon!
            </Paragraph>
            <div
              onClick={() => {
                history.push('/studentDetails');
              }}
              role="button"
              className="come-back-btn"
            >
              <p>Back</p>
            </div>
          </div>
        </div>

        <div className="footer-wrapper">
          <footer className="footer" />
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignContent: 'center',
              justifyContent: 'center',
              position: 'relative',
              top: '20px',
            }}
          >
            {date.map((element, i) => {
              if (date.length - 1 === i) {
                return (
                  <Paragraph className="time" key={i}>
                    {' '}
                    {element}
                  </Paragraph>
                );
              }
              return (
                <div style={{ display: 'flex', flexDirection: 'row' }} key={i}>
                  <Paragraph className="time">{element}</Paragraph>
                  <Paragraph className="time colored"> : </Paragraph>
                </div>
              );
            })}
          </div>
        </div>
      </MainContainer>
    );
  }
}
ComingSoon.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
};
